<template>
  <section class="ugc-custom-pattern-upload">
    <div class="ugc-custom-pattern-upload-wrapper">
      <button
        @mouseover="handleHover($event, true)"
        @mouseleave="handleHover($event, false)"
        type="button"
        class="button ugc-tray-wrapper-button"
        :style="{ 'background-image': `url(${ customsAssets }/images/customizer/pattern_maker_cta_bg.png)`}"
        :disabled="isPatternDisabled"
        @click="clicked"
      >
        {{ textLabel || translations[inputLabel] }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "pattern-Upload",
  props: {
    inputId: {
      type: String,
      default: "custom-pattern-uploader-input"
    },
    textLabel: {
      type: String,
      default: null
    },
    inputLabel: {
      type: String,
      default: "checkerboardUpload"
    },
    onClick: {
      type: Function,
      default: null
    },
    disableButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    isPatternDisabled() {
      return this.disableButton || this.$store.getters["utils/isGCC"];
    },
    checkerboarderActive() {
      return this.$store.state.UGCEntryPoint.checkerboarder.active;
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    }
  },
  methods: {
    isSecondComponentFlow() {
      const secondaryComponent = this.$store.getters["ugc/getUGCComponentNotActive"];
      const patternAlreadyCreated = this.$store.state.patternMaker.currentPattern.hasOwnProperty(secondaryComponent);

      return secondaryComponent && patternAlreadyCreated;
    },
    handleHover(e, hovered) {
      if (hovered) {
         e.target.style.backgroundSize = ' 0 0';
      } else {
        e.target.style.backgroundSize = 'cover';
      }
    },
    clicked(e) {
      if (this.$store.getters["utils/isGCC"]) {
        return;
      }
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "ugc");
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_COMPONENT", this.$store.state.standardNavigation.activeComponent);
      this.$modal.show("patternMaker");

      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$customizerDataLayer.logAnalyticsEvent({
          type: this.$customizerDataLayer.types.customizerCreateYourOwn,
          eventLabel: 'Pattern Maker'
        });
      } else {
        this.$ugcDataLayer.logAnalyticsEvent({
          action: this.checkerboarderActive ? 'checkerboarder' : 'ugc',
          type: this.$ugcDataLayer.types.customPattern
        });
        dataLayer.push({
          'event': 'trackEvent',
          'eventCategory': 'customs',
          'eventAction': `pattern maker${ this.isSecondComponentFlow() ? ' - second component' : ''}`,
          'eventLabel': 'pattern maker entry'
        });
      }
      if (this.onClick) {
        this.onClick(e);
      }
    }
  }
}
</script>
